module.exports = __webpack_public_path__ + "img/dna4_600.ca53f0a8.jpg";